<template>
    <div class="auth-block login-form">
        <h1 class="auth-block-header">{{$t('login.LOGIN_FORM_WELCOME')}}</h1>
        <span class="auth-block-text">{{$t('login.LOGIN_FORM_SELECT_METHOD')}}</span>
        <div v-if="services.form" class="form">
            <label>
                <input v-model="form.email" :placeholder="$t('login.LOGIN_FORM_LOGIN_PLACEHOLDER')" />
            </label>
            <label>
                <input v-model="form.password" type="password" :placeholder="$t('login.LOGIN_FORM_PASSWORD_PLACEHOLDER')"/>
            </label>
            <transition name="component-fade-route" mode="out-in">
                <p v-html="form.error" class="form-error"></p>
            </transition>
            <button class="button" @click="login" style="margin-top:20px;">
                <LoadingIndicator
                    v-if="loadingButton"
                    style="position: absolute; right: 17px; width: 2rem; height: 2rem"
                    class="white"
                />
                {{$t('login.LOGIN_FORM_PRIMARY_BUTTON_LABEL')}}
            </button>
            <transition name="component-fade-route" mode="out-in">
                <a :href="getHomepage()" style="width:100%;text-decoration:none;">
                <button class="button secondary" style="margin-top: 10px;width:100%;">
                    {{$t("login.LOGIN_FORM_REGISTER_BUTTON")}}
                </button>
                </a>
            </transition>
            <transition name="component-fade-route" mode="out-in">
                <a v-if="showForgetPasswordButton" href="#" class="btn link-btn" style="margin-top: 10px;">{{$t("login.LOGIN_FORM_FORGET_PASSWORD_BUTTON")}}</a>
            </transition>
        </div>
        <div v-if="services.google" class="form">
            <div class="google-login-button noselect" @click="loginGoogle">
                <img src="../../../assets/img/google.svg" alt="fb">
                <span>{{$t('login.LOGIN_FORM_GOOGLE_BUTTON_LABEL')}}</span>
            </div>
        </div>
        <div v-if="services.facebook" class="form" :style="services.google?'margin-top:10px !important;':''">
            <div class="fb-login-button noselect" @click="loginFB">
                <img src="../../../assets/img/fb.svg" alt="fb">
                <span>{{$t('login.LOGIN_FORM_FACEBOOK_BUTTON_LABEL')}}</span>
            </div>
        </div>
        <div class="support-button" @click="VerboxSupportOpen">
            <div class="icon icon-help-circle"></div>
            <span>{{$t('strings.TECHNICAL_SUPPORT')}}</span>
        </div>
    </div>
</template>

<script>
    import CheckBox from '@/components/checkbox/CheckBox.vue'
    import lStorage from '@/store/localStorage.js';
    import Cookie from '@/store/cookie.js';
    import env from '@/enviroment';
    import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
    import enviroment from "@/enviroment";
    import i18n from "@/i18n";
    import {rest} from '@/utils/utils';

    export default {
        name: 'Login',
        components: {
            CheckBox,
            LoadingIndicator,
        },
        data: function() {
            return {
                showForgetPasswordButton:enviroment.auth.show_forget_password_button,
                loadingButton:false
            }
        },
        props:{
            services:{
                type:Object,
                required:true,
                default:{}
            },
            form:{
                type:Object,
                required:true,
                default:{}
            },
            registration:{
                type:Object,
                required:true,
                default:{}
            },
        },
        methods: {
            getHomepage:()=>{
                return env.homepage;
            },
            login(){
                this.form.error = '';
                this.loading = true;

                rest.call("auth",{
                    'user_auth': {
                        "email":this.form.email,
                        "password":this.form.password
                    },
                    "language":i18n.locale,
                    "elev_id":this.$route.query.elev_id || ""
                },"POST",false).then((response)=>{
                    if(response.id){
                        lStorage.set('auth-token', response.id);
                        Cookie.set("auth-token",response.id,{
                            "max-age":3600*30,
                            "domain":"."+env.domain
                        });
                        this.loading = false;
                        this.$router.push({
                            name:"lesson",
                            params:{
                                locale:i18n.locale,
                            }
                        });
                    }else{
                        this.loading = false;
                        if(response.number){
                            this.form.error = i18n.t("soap."+response.number);
                        }else if(response.description){
                            this.form.error = response.description;
                        }
                    }
                }).catch((error)=>{
                    this.loading = false;
                    this.form.error = error.response.description || "";
                });
            },
            loginFB:function(){
                window.location = env.URL + '/index.php?entryPoint=client_auth&provider=facebook&action=login&deal_id='+(this.$route.query.elev_id || "")+"&language="+i18n.locale;
            },
            loginGoogle: function () {
                window.location = env.URL + '/index.php?entryPoint=client_auth&provider=google&action=login&deal_id='+(this.$route.query.elev_id || "")+"&language="+i18n.locale;
            },
            register(){
                this.$router.push({
                    name:"registration",
                    params:{
                        locale:i18n.locale,
                    }
                });
            },
            /**
             * Открывает окно чата
             */
            VerboxSupportOpen(){
                Verbox("openSupport");
            },
            /**
             * Открывает окно отзывов
             */
            VerboxFeedBackOpen(){
                Verbox("openReviewsTab");
            },
        },
        computed:{}
    }
</script>

<style lang="scss" scoped>
    .form-error{
        
    }
    .form{
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 370px;
        height: auto;
        margin-top: 30px !important;
        &:first-child{
            margin-top:0px !important;
        }
        input {
            width: 100%;
            background: #FFFFFF;
            border-radius: 50px;
            font-family: FuturaPT;
            font-style: normal;
            font-weight: 500;
            border: 0;
            outline: none;
            color: #263238;
            margin-bottom: 13px;
            font-size: 21px;
            line-height: 63px;
            padding: 0px 30px;
            &::placeholder{
                color:#b5b7bc;
            }
        }
        button {
            padding: 18px 32px;
            position: relative;
            font-size: 21px;
            border-radius: 50px;
            line-height: 26px;
            letter-spacing: .7px;
            &.secondary{
                background: #fff;
                color: rgba(11,16,34,.3);
            }
        }
        .form-error {
            padding-top: 10px;
        }
        .fb-login-button {
            background: #FFFFFF;
            border-radius: 50px;
            padding: 16px 32px;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                margin-right: 20px;
                width: 32px;
                height: auto;
            }

            span {
                font-family: FuturaPT;
                font-size: 21px;
                line-height: 16px;
                letter-spacing: .5px;
                color: #0B1022;
            }

            &:hover {
                box-shadow: 0px 2px 4px #C8C8C8;
            }
        }

        .google-login-button {
            background: #FFFFFF;
            border-radius: 50px;
            padding: 16px 32px;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                margin-right: 20px;
                width: 32px;
                height: auto;
            }

            span {
                font-family: FuturaPT;
                font-size: 21px;
                line-height: 16px;
                letter-spacing: .5px;
                color: #0B1022;
            }

            &:hover {
                box-shadow: 0px 2px 4px #C8C8C8;
            }
        }
    }
    
    .support-button{
        background: #FFFFFF;
        border-radius: 50px;
        padding: 16px 32px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        color: rgba(11,16,34,.3);
        margin-top: 50px;
        &>.icon{
            width: 32px;
            height: 32px;
            font-size: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
        }
        &>span{
            font-family: FuturaPT;
            font-size: 21px;
            line-height: 16px;
            letter-spacing: .5px;
        }
        &:hover{
            color:#cf0920;
        }
    }
</style>